import React from 'react';
import { Typography } from '@mui/material';

interface StoreSummarySubscriptionStatusCellProps {
  status: string | null;
}

const StoreSummarySubscriptionStatusCell: React.FC<StoreSummarySubscriptionStatusCellProps> = ({ status }) => {
  const normalizedStatus = (status || '').toLowerCase();

  const label =
    normalizedStatus === 'pending_cancel'
      ? 'Pending Cancel'
      : normalizedStatus === 'pending_activation'
        ? 'Pending Activation'
        : normalizedStatus === 'cancelled' || normalizedStatus === 'canceled'
          ? 'Canceled'
          : status
            ? status.charAt(0).toUpperCase() + status.slice(1)
            : 'N/A';

  return (
    <Typography sx={{ color: '#222B45', fontSize: '13px', fontWeight: 400, lineHeight: 1.2, textAlign: 'left' }}>
      {label}
    </Typography>
  );
};

export default React.memo(StoreSummarySubscriptionStatusCell);
